/**
 * Ponto de entrada da SPA Nava Flow.
 *
 * Hierarquia de providers (ordem importa):
 *   BrowserRouter       — fornece o contexto de roteamento
 *     AuthProvider      — OIDC stub + gestão de tokens em memória
 *       ApiProvider     — cliente HTTP autenticado + QueryClient
 *         AppRouter     — rotas + NavigationProvider + NavaStyles
 *
 * Por que AuthProvider está fora do AppRouter:
 *   O AuthGuard (dentro do AppRouter) consome useAuth(); se AuthProvider
 *   estivesse dentro do AppRouter, o Guard não teria o contexto disponível
 *   ao avaliar se a rota é pública ou protegida.
 *
 * Por que ApiProvider está entre Auth e AppRouter:
 *   O ApiProvider recebe getToken do AuthContext; ao ficar abaixo de
 *   AuthProvider, o token atualizado é sempre lido no momento do fetch.
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '@/auth/AuthContext';
import { ApiProvider } from '@/api/ApiProvider';
import { ThemeProvider } from '@/theme/ThemeProvider';
import { AppRouter } from './AppRouter';
import { PRODUCT_NAME } from '@/theme/branding';
import './index.css';

// Título da aba a partir do ponto único de marca (index.html é o fallback pré-JS).
document.title = PRODUCT_NAME;

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <ApiProvider>
          <ThemeProvider>
            <AppRouter />
          </ThemeProvider>
        </ApiProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
